import React, { useMemo, useState, useEffect } from "react";
import Customtable from "../../helper/Customtable";
import Swal from 'sweetalert2';
import { post } from "../../helper/api_helper"

const Role = () => {
    const initialFormState = {
        role_id: 0,
        role_name: '',
        status: '0'
    };

    const [formData, setFormData] = useState(initialFormState);
    const [validated, setValidated] = useState(false);
    const [roleList, setroleList] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const columns = useMemo(
        () => [
            {
                header: 'S.No',
                label_condition: 's_no',
                enableColumnFilter: false,
                enableSorting: false,
            },
            {
                header: 'Actions',
                cell: ({ row }) => (
                    <>
                        <i
                            className="ri-file-edit-fill text-primary cursor-pointer me-2"
                            onClick={() => handleEdit(row)}
                            title="Edit"
                            style={{ fontSize: "18px" }}
                        />
                    </>
                ),
                enableSorting: false,
                enableColumnFilter: false,
            },
            {
                header: 'Role',
                accessorKey: 'role_name',
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: 'Status',
                accessorKey: 'status',
                enableColumnFilter: false,
                enableSorting: true,
                label_condition: 'status',
            },
        ],
        []
    );

    const handleEdit = (row) => {

        setFormData({
            role_id: row.role_id,
            role_name: row.role_name,
            status: row.status
        });
    };


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const showAlert = (icon, title, text, timer = 2000) => {
        Swal.fire({ icon, title, text: text || 'Something went wrong.', timer, showConfirmButton: false });
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.stopPropagation();
            showAlert('error', 'Oops...', 'Please fill in all required fields.');
            setValidated(true);
        } else {
            try {
                setValidated(false);
                const response = await post("/settings/role", formData);
                if (response.status === 200) {
                    showAlert('success', 'Saved', response.message);
                    fetchData();
                    setFormData(initialFormState);
                } else {
                    showAlert('error', response.status, response.message);
                }
            } catch (err) {
                showAlert('error', 'Unexpected Error', err.message);
            }
        }
        
    };

    const handleReset = () => {
        setFormData(initialFormState);
        setValidated(false);
    };

    const fetchData = async () => {
        try {
            const response = await post("/settings/role_list");
            if (response.status === 200) {
                setroleList(response.data);
            } else {
                showAlert('error', response.status, response.message);
            }
        } catch (err) {
            showAlert('error', 'Unexpected Error', err.message);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
       <React.Fragment>
      <div className="row">
        <div className="col-lg-3">
          <div className="card">
            <form noValidate className={validated ? "was-validated" : ""} onSubmit={handleSubmit}>
              <div className="card-header">
                <h5 className="card-title mb-0">Role</h5>
              </div>
              <div className="card-body">
                <div className="row g-3">
                    <div className="col-sm-12">
                        <label>Role</label>
                        <input
                            name="role_name"
                            className="form-control"
                            placeholder="Enter Role Name"
                            type="text"
                            id="role_name"
                            value={formData.role_name}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="col-sm-12">
                        <label>Status</label>
                        <select
                        className="form-control"
                        name="status"
                        value={formData.status}
                        onChange={handleChange}
                        >
                        <option value="0">Active</option>
                        <option value="1">In-Active</option>

                        </select>
                    </div>
                </div>
              </div>
              <div className="card-footer">
                <div className="row">
                  <div className="col-md-12">
                    <button type="submit" className="btn btn-primary btn-sm" style={{ float: "right"}}>SAVE</button>
                    <button type="button" onClick={handleReset} className="btn btn-sm btn-secondary">Clear</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div className="col-lg-9">
          <div className="card basic-data-table">
            <div className="card-header">
              <h5 className="card-title mb-0">Role List</h5>
            </div>
            <div className="card-body">
              <Customtable
                table_title="role List"
                columns={columns}
                data={roleList}
                isGlobalFilter={true}
                isPagination={true}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                isExportButton={true}
              />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
    );
};

export default Role;
